<template>
  <div>
    <div class="faq-content" :class="{'is-faq-page': isCurrentPageFaq}">
      <span class="no-records" v-if="!faq.length">No entries</span>
      <Accordion :content="faqState"></Accordion>
    </div>
    <div v-if=isCurrentPageFaq class="back-to-top-container">
      <BackToTop selector="#faqs"></BackToTop>
    </div>
  </div>
</template>

<script>
import Menu from '@/components/custom/Menu';
import CustomMap from '@/components/custom/CustomMap';
import PageContent from '@/components/abstract/PageContent';
import {mapGetters, mapActions} from 'vuex';
import BackToTop from '@/components/custom/BackToTop';
import Accordion from '@/components/custom/Accordion';
import {FAQS} from '@/enum/screens.enum';

export default {
  data() {
    return {
      faqState: []
    }
  },
  components: {Menu, CustomMap, PageContent, BackToTop, Accordion},
  computed: {
    ...mapGetters('map', ['faq']),
    isCurrentPageFaq: function () {
      return this.$router.history.current.path === '/faq'
    }
  },
  watch: {
    'faq': {
      handler: function () {
        this.faqState = this.faq.map((item) => ({
          id: item.weight,
          active: false,
          title: item.question,
          details: item.answer
        }))
      }
    }
  },
  methods: {
    ...mapActions('map', ['loadFaq', 'screenVisited'])
  },
  mounted() {
    this.loadFaq();
    this.screenVisited({ screen: FAQS });
  }
}
</script>

<style lang="stylus" scoped>
@import 'nib'

.back-to-top-container
  absolute bottom 16px right 50px

.no-records
  padding 12px
  font-family "Open Sans", sans-serif
  color #6e6e6e

.faq-content
  display flex
  flex-direction column
  min-height 200px
  .no-records
    margin: auto

  &.is-faq-page
    margin-bottom 60px
    @media screen and (max-width 768px)
      margin-bottom 0

</style>



// WEBPACK FOOTER //
// src/components/pages/FaqContent.vue